import { FC } from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { WrapDrawerCreateForm } from '../index'
import { useRpLimitForm } from './useRpLimitForm'
import RpLimitFormBase from './base'
import { CreateRpLimitPayload } from '../../prp2boxApi/limits'
import { Prp2boxApiLimit } from '../../prp2boxApi'
import { EQueryKeysConstant } from '../../constants/EQueryKeysConstant'
import { TRpLimitFormData } from './schema'

const RpLimitFormCreate: FC = () => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useRpLimitForm()

  const queryClient = useQueryClient()

  const createLimitMutation = useMutation((newLimit: CreateRpLimitPayload) => Prp2boxApiLimit.createLimit(newLimit), {
    onSuccess: () => {
      toast.success('Лимит успешно создан')

      queryClient.invalidateQueries([EQueryKeysConstant.RP_LIMITS])
    },
  })

  const handleSave = (data: TRpLimitFormData) => {
    const { max = null, maxPayout = null, ...rest } = data

    createLimitMutation.mutate({
      ...rest,
      max,
      maxPayout,
    })
  }

  return (
    <WrapDrawerCreateForm title="Создание нового лимита" onSave={handleSubmit(handleSave)}>
      <RpLimitFormBase register={register} errors={errors} />
    </WrapDrawerCreateForm>
  )
}

export default RpLimitFormCreate
